import { Box, Chip, Link, Stack, styled } from '@mui/material';

export const DeveloperTabRoot = styled(Stack)({
  flex: 1,
  height: '100%',
  overflow: 'auto',
});

export const DeveloperHeader = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  padding: theme.spacing(3, 3, 1, 3),
  gap: theme.spacing(2),
}));

export const DeveloperHeaderText = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(0.5),
  flex: 1,
}));

export const DeveloperDocsLink = styled(Link)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  width: 'fit-content',
  marginTop: theme.spacing(0.5),
  color: theme.palette.primary.main,
  fontWeight: 500,
  '& .MuiSvgIcon-root': {
    fontSize: theme.typography.pxToRem(16),
  },
}));

export const DeveloperBody = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, 3, 3, 3),
  flex: 1,
}));

export const EmptyStateCard = styled(Stack)(({ theme }) => ({
  border: `1px dashed ${theme.palette.custom.OV.sys.outlineVariant}`,
  borderRadius: theme.shape.borderRadius * 3,
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(8, 3),
  backgroundColor: theme.palette.custom.OV.sys.surfaceContainerLowest,
}));

export const EmptyStateIconBubble = styled(Box)(({ theme }) => ({
  width: '3rem',
  height: '3rem',
  borderRadius: '50%',
  backgroundColor: theme.palette.custom.OV.sys.surfaceContainerHighest,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const RevokedChip = styled(Chip)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  backgroundColor: theme.palette.custom.OV.sys.surfaceContainerHighest,
  color: theme.palette.custom.OV.sys.onSurfaceVariant,
}));

export const NameCell = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
});

export const MaskedKeyCell = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
  fontFamily: 'monospace',
}));

export const RevokedText = styled('span')(({ theme }) => ({
  color: theme.palette.custom.OV.sys.onSurfaceVariant,
  opacity: 0.65,
}));

export const ApiKeysTableWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  border: `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,
  borderRadius: '0.75rem',
  overflow: 'hidden',
}));
